import React from 'react'
import { useParams } from 'react-router-dom'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { Menu, MenuAdd, MenuDelete, MenuEdit } from '../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { useApiListRoleOrgPermission } from '../../../../../api-new/state/content'
import { IconList } from '../../../../../shared/icon/icon'
import { TableAgClient } from '../../../../../shared/table-builder/table-ag-client'
import { ColumnLink, ColumnMenu, ColumnText, ColumnYesNo } from '../../../../../shared/table-builder/table-columns'

export const RoleOrgPermissionListRole = () => {
  const { roleOrg } = useParams()

  const apiListRoleOrgPermission = useApiListRoleOrgPermission()

  const handleReady = () => apiListRoleOrgPermission.get(`${roleOrg}/role`)
  const handleDestroyed = () => apiListRoleOrgPermission.init()

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd text="add role permission" to={'/root/role-org-permission/list/add'} show />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text={roleOrg}>
        <CardFullHeightScrollY title={`role permission ${roleOrg}`} HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListRoleOrgPermission} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="roleName" header="role" />

            <ColumnLink field="identifier" header="scope" to={row => `/root/role-org-permission/list/identifier/${row.identifier}`} sortable filter />

            <ColumnYesNo field="accessCreate" header="create" />
            <ColumnYesNo field="accessRead" header="read" />
            <ColumnYesNo field="accessUpdate" header="update" />
            <ColumnYesNo field="accessDelete" header="delete" />

            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuEdit to={`/root/role-org-permission/list/edit/${row.id}`} show />
                  <MenuDelete to={`/root/role-org-permission/list/edit/${row.id}/delete`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
